<template>
    <div>
        <div class="writing_nav">
            <div class="writing_nav_con">
                <router-link to="/memberCentre/basicInformation" active-class="active" class="writing_nav_list" :class="{'active': $route.meta.requiresAuth}"><span><img src="@a/img2/sv82.svg"/><img src="@a/img2/sv82on.svg"/></span>基本信息</router-link>
                <router-link to="/memberCentre/loginLog" active-class="active" class="writing_nav_list"><span><img src="@a/img2/sv83.svg"/><img src="@a/img2/sv83on.svg"/></span>登录日志</router-link>
                <!-- <router-link to="/memberCentre/signInWith" active-class="active" class="writing_nav_list">第三方登录</router-link> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "memberCentreNav",
        data() {
            return {
                
            };
        },
        computed: {
            
        },
        methods:{
           
        },
    }
</script>

<style scoped>
    @import "memberCentreNav.css";
</style>